import { useIsAuthenticated, auth } from "marvin-auth-kit";
import { ReactElement } from "react";
import { useOutletContext, Outlet } from "react-router-dom";
import axios from "axios";

interface Props {
  loader: ReactElement;
}

export const IsAuthenticedGuard = (props: Props): ReactElement => {
  const { loader } = props;
  const context = useOutletContext();
  const [isLoading] = useIsAuthenticated();

  auth.applyInterceptors(axios);

  return (
    <>
      {isLoading && loader}
      {!isLoading && <Outlet context={context} />}
    </>
  );
};
